import type { TileKey, WorldState } from "../models/worldState.ts";
import { selectSelectableTiles } from "./mapTiles.ts";

export type TileInteractionIntent = "chooseStart" | "move" | "none";

export interface TileInteractionView {
  readonly pickable: readonly TileKey[];
  readonly intent: TileInteractionIntent;
}

export function selectTileInteraction(state: WorldState): TileInteractionView {
  if (state.phase === "selectingStart") {
    return {
      pickable: selectSelectableTiles(state),
      intent: "chooseStart",
    };
  }

  if (state.phase === "playing") {
    return {
      pickable: selectSelectableTiles(state),
      intent: "move",
    };
  }

  return { pickable: [], intent: "none" };
}
